import { restRequest } from "vrcore-dashboard/dist/utilities";

export const SET_NEW_FEATURE = restRequest("FEATURE.SET_NEW_FEATURE");
export const REMOVE_FEATURE = restRequest("FEATURE.REMOVE_FEATURE");
export const GET_FEATURES = restRequest("FEATURE.GET_FEATURES");
export const EDIT_FEATURE = restRequest("FEATURE.REMOVE_FEATURE");
export const UPLOAD_FILE = restRequest("SUPPORT.UPLOAD_FILE");